type ScrollTargets = {
	first: HTMLElement | null;
	current: HTMLElement | null;
	last: HTMLElement | null;
	next: HTMLElement | null;
};

/**
 * Returns the elements that could be relevant scroll targets relative to the current scroll position.
 */
export const findScrollTargets = (scroller: HTMLElement) => {
	const targets: ScrollTargets = {
		first: null,
		last: null,
		current: null,
		next: null,
	};

	// This loops through every child, but that shouldn't be a performance problem because we only
	// intend to have ~20 children to check every 2 seconds.
	Array.from(scroller.children).forEach((el) => {
		if (!(el instanceof HTMLElement)) {
			return;
		}

		if (!targets.first) {
			targets.first = el;
		}

		if (!targets.current) {
			if (checkScrollVisibility(scroller, el).top) {
				targets.current = el;
			}
		} else if (!targets.next) {
			targets.next = el;
		}

		targets.last = el;
	});

	return targets;
};

export type ScrollVisibility = {
	top: boolean;
	bottom: boolean;
};

export const checkScrollVisibility = (scroller: HTMLElement, child: HTMLElement): ScrollVisibility => {
	// For vertical scrolling, "top" means the element is at or below the current scroll position
	// This matches the original horizontal logic where "left" meant the element was at or to the right of scroll position
	const top = scroller.scrollTop <= child.offsetTop;
	const bottom = child.offsetTop + child.offsetHeight <= scroller.scrollTop + scroller.clientHeight;
	return { top, bottom };
};
